<template>
    <div class="blackBg animate__animated animate__slideInLeft">
        <div class="cardTit">
            <span class="teamName">训练教案</span>
            <div class="tagsList left">
                <span v-for="(item,index) in tags" v-if="index <= 3" :key="item.key" :class="tagsCheck == item.key ? 'check' : ''">{{item.value}}</span>
            </div>
            <div class="tagsList right">
                <span v-for="(item,index) in tags" v-if="index > 3" :key="item.key" :class="tagsCheck == item.key ? 'check' : ''">{{item.value}}</span>
            </div>
        </div>
        <div class="lesson">
            <div class="lessonList">
                <div class="item" v-for="(item,index) in lessonList" :key="item.id">
                    <img v-if="item.videoUrl" class="videoIcon" src="../assets/img/icon/videoIcon.svg" alt="">
                    <span class="number">{{index+1}}</span>
                    <img :src="item.drawingThumbnail ?
                    ((typeof item.drawingThumbnail == 'string')  ? item.drawingThumbnail : item.drawingThumbnail[item.drawingThumbnail.length-1])
                     : require('@/assets/img/updateImg/exerciseBg.png')" alt="">
                    <div class="message">
                        <p class="list-item-tit-msg">{{item.title}}</p>
                        <span class="user">
                            <img v-if="item.creatorAvatar" :src="item.creatorAvatar" alt="">
                            <img v-else src="../assets/img/updateImg/playerHead.png" alt="">
                        </span>
                        <div class="list-item-tags">
                            <p class="list-item-tags-col"><i class="icon-user"></i><span v-if="item.tags">{{labelVal(item.tags,"tags")}}</span>
                            </p>
                            <p class="list-item-tags-col"><i class="icon-age"></i><span v-if="item.age">{{labelVal(item.age,"age")}}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer">
                <span class="prev" @click="changePage(-1)">上一页</span>
                <span class="next" @click="changePage(1)">下一页</span>
                <span class="page"><i>{{page}}</i>/{{totalPages}}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "lessonPlan",
    data() {
        return {
            teamName: this.$store.state.teamName ? this.$store.state.teamName.split('_')[0] : '',//梯队名称
            tags: [],//类型
            tagsCheck: 'all',
            lessonList: [],
            page: 1,//页码
            totalPages: 0,//总页数
            labelList: {},//教案标签
        }
    },
    computed: {
        lookCommandFn() {
            return this.$store.state.lookCommand;
        },
    },
    watch: {
        page: {
            handler(val, old) {
                this.getLessonList();
            },
            deep: true
        },
        lookCommandFn: {
            async handler(val, old) {
                let tags = this.tags;
                let lessonList = this.lessonList;
                let prevPage = this.$aiJson.prevPage;
                let nextPage = this.$aiJson.nextPage;
                let flag = 0;
                let speak = '';
                let routerObj = {};
                 //标签判断
                 for (let item = 0; item < tags.length; item++){
                     if (eval('/' + tags[item].value + '/gi').test(val)) {
                         flag = 1;
                         this.tagsCheck = tags[item].key;
                         speak = tags[item].value;
                         this.page = 1;
                         this.getLessonList();
                         break;
                     } else {
                         flag = 0;
                     }
                 }
                //教案号判断
                if(!flag){
                    for (let item = 0; item < lessonList.length; item++){
                        if (eval('/' + this.$aiJson.itemNum[item] + '号' + '/gi').test(val)) {
                            flag = 1;
                            //查看详情
                            speak = 'detail';
                            routerObj={
                                path: '/about/lessonDetail',
                                name: 'lessonDetail',
                                query: {
                                    id: this.lessonList[item].id,
                                    page: this.page,
                                    tagsCheck: this.tagsCheck
                                },
                                goType:1
                            }
                            break;
                        } else {
                            flag = 0;
                        }
                    }
                }

                //上一页判断
                if(!flag){
                    for (let item = 0; item < prevPage.length; item++){
                        if (eval('/' + prevPage[item] + '/gi').test(val)) {
                            flag = 1;
                            speak = this.page != 1 ? '俱乐部' : '';
                            this.changePage(-1);
                            break;
                        } else {
                            flag = 0;
                        }
                    }
                }
                //下一页判断
                if(!flag){
                    for (let item = 0; item < nextPage.length; item++){
                        if (eval('/' + nextPage[item] + '/gi').test(val)) {
                            flag = 1;
                            speak = this.page != this.totalPages ? '俱乐部' : '';
                            this.changePage(1);
                            break;
                        } else {
                            flag = 0;
                        }
                    }
                }

                if(flag){
                    if(speak!=''){
                        if(speak == 'detail'){
                            this.$store.dispatch("setFlag",'1_'+new Date().getTime());//vuex改变识别信息
                            // this.$store.state.promptMsg='返回，或者 回到开始'
                            // console.log(routerObj)
                            this.$store.dispatch("setRouter", routerObj);//vuex改变路由
                        }else {
                            this.$parent.$parent.imgAi(this.$imgJson.handAiImgArr);
                            this.$parent.$parent.audioPlayFn(this.$global.audioPlayUrl('这是'+ speak + '的训练教案'), true, false)
                        }
                    }
                }else {
                    this.$store.dispatch("setFlag",'0_'+new Date().getTime());//vuex改变识别信息
                }
            },
            deep: true
        },
    },
    mounted() {
        // console.log(this.$store.state.pageParams)
        // console.log(this.$route)
        this.$parent.$parent.imgAi(this.$imgJson.handAiImgArr);
        this.$parent.$parent.audioPlayFn(this.$global.audioPlayUrl('这是俱乐部的训练教案'), true, true, 1);
        if (this.$store.state.pageParams.id) {
            this.page = this.$store.state.pageParams.page;
            this.tagsCheck = this.$store.state.pageParams.tagsCheck;
        }
        this.labelFn();
        this.getTags();
        if (this.page == 1) {
            this.getLessonList();
        }
    },
    methods: {
        getTags() {
            this.$server.commonDataTit({key: 'tags'})
                .then(res => {
                    let arr = [{key: 'all', value: '全部'}];
                    this.tags = arr.concat(res.data);
                })
        },
        getLessonList() {
            // console.log(this.tagsCheck)
            let data = {
                tags: this.tagsCheck == 'all' ? '' : this.tagsCheck,
                pageSize: 10,
                page: this.page,
            }
            this.$server.getExerciseList(data)
                .then(res => {
                    this.lessonList = res.data.list;
                    this.totalPages = res.data.pages;
                })
        },
        //翻页
        changePage(type) {
            if (type > 0) {
                if (this.page == this.totalPages) {
                    //当前是最后一页
                    this.$parent.$parent.audioPlayFn(this.$global.audioPlayUrl(this.$aiJson.playVoice.lastPage), true, false)
                } else {
                    this.page++
                }
            } else {
                if (this.page == 1) {
                    //当前是第一页
                    this.$parent.$parent.audioPlayFn(this.$global.audioPlayUrl(this.$aiJson.playVoice.firstPage), true, false)
                } else {
                    this.page--
                }
            }
        },
        //教案标签
        labelFn() {
            this.$server.commonDataTit({key: 'tags'})
                .then(res => {
                    this.labelList["tags"] = res.data;
                });
            this.$server.commonDataTit({key: 'age'})
                .then(res => {
                    this.labelList["age"] = res.data;
                })
        },
        //教案标签序列化
        labelVal(value, type) {
            let valueArr = value.split(",");
            let labelStr = "";
            let list = this.labelList[type];
            if(list && list.length){
                for (let i = 0; i < list.length; i++) {
                    for (let j = 0; j < valueArr.length; j++) {
                        if (list[i].key == valueArr[j] && valueArr[j] != "") {
                            labelStr += list[i].value + " "
                        }
                    }
                }
            }

            return labelStr
        },
    }
}
</script>

<style scoped lang="less">
.cardTit {
    margin-top: 2vw;
    font-size: 30px;
    box-sizing: border-box;
    position: relative;
    .tagsList{
        color: #fff;
        position: absolute;
        top: .4vw;
        &.left {
            left: 1vw;
        }
        &.right {
            right: 1vw;
            span{
                margin-right: 0;
                margin-left: 0.5vw;
            }
        }
        span{
            box-sizing: border-box;
            background-color: rgba(216, 216, 216, .1);
            color: rgba(255, 255, 255, .6);
            font-size: 24px;
            padding: 0.2vw .8vw;
            margin-right: 0.5vw;
            &.check{
                border: 1px solid var(--primary-color);
                color: var(--primary-color);
                background-color: rgba(66, 165, 245, 0.3);
            }
        }
    }
}
.lessonList {
    color: #fff;
    margin-top: 0.5vw;
    min-height: 34vw;
    .item {
        width: calc((100% - (1vw*4)) / 5);
        float: left;
        margin-right: 1vw;
        margin-bottom: 1.5vw;
        position: relative;
        overflow: hidden;
        height: 15.5vw;
        .videoIcon{
            position: absolute;
            top: .2vw;
            right: .2vw;
            width: 2vw !important;
        }
        &:nth-child(5n){
            margin-right: 0;
        }

        img {
            /*height: 100%;*/
            width: 100%;
        }
        .number{
            border: 2px solid rgba(255, 255, 255, 0.3);
            width: 2vw;
            height: 2vw;
            background-color: var(--primary-color);
            border-radius: 50%;
            text-align: center;
            line-height: 1.8vw;
            font-size: 34px;
            position: absolute;
            font-family: akrobatBold;
            top: .2vw;
            left: .2vw;
        }
        .message{
            color: rgba(255, 255, 255,.8);
            font-size: 20px;
            background: linear-gradient(0deg, rgba(14, 14, 14, 0.7) 0%, rgba(14, 14, 14, 0) 100%);
            height: 3vw;
            width: 100%;
            position: absolute;
            bottom: 0;
            .user {
                display: inline-block;
                width: 2vw;
                height: 2vw;
                border-radius: 50%;
                overflow: hidden;
                position: absolute;
                right: .5vw;
                top: -.5vw;
                img{
                    width: 100%;
                }
            }
            .list-item-tit-msg{
                line-height: 1.5vw;
                padding-left: .5vw;
                padding-right: 3vw;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space:nowrap;
            }
            .list-item-tags {
                clear: both;
                text-align: left;
                padding-left: .6vw;
                padding-right: .5vw;
                box-sizing: border-box;

                p {
                    width: 50%;
                    display: inline-block;
                }

                i {
                    display: inline-block;
                    width: 16px;
                    height: 16px;
                    margin-bottom: -3px;
                }

                i.icon-user {
                    background: url("../assets/img/updateImg/hot.svg") no-repeat center center;
                    background-size: 100% 100%;
                }

                i.icon-age {
                    background: url("../assets/img/updateImg/team.svg") no-repeat center center;
                    background-size: 100% 100%;
                }

                .list-item-tags-col {
                    white-space: nowrap;
                    overflow: hidden;

                    span {
                        padding-left: .3vw;
                        font-size: 16px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: rgba(255, 255, 255, .7);
                    }
                }
            }
        }
    }
}
</style>
